module.exports = __webpack_public_path__ + "static/turning-0f164d8c9fc5ebbdcab2b78a897565f2.mp4";